/** Booleans values to use in Drive Module */
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useMainStore } from '@/store/mainStore';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { ACCOUNT_STATUS, NAVIGATION_PAGES, SHARE_SETTINGS } from '@/types/enums';
import { INavigation } from '@/types/interfaces';

export default function useDriveBooleans() {
  const mainStore = useMainStore();
  const driveStore = useDriveStore();
  const route = useRoute();
  const currentPage = computed(() => (route.meta.navigationPage));

  /** Boolean value shows is account is Corporate or not - depend on value, tabs translation changed */
  const isCorporate = computed(() => mainStore.user?.accountStatuses?.includes(ACCOUNT_STATUS.SUB_ACCOUNT) || mainStore.user?.accountStatuses?.includes(ACCOUNT_STATUS.CORPORATE_ACCOUNT));

  /** Boolean value should be true if we at Drive My */
  const isDrive = computed(() => (currentPage.value === NAVIGATION_PAGES.DRIVE));

  /** Boolean value is true if we open Drive all Cases [Drive -> (My) -> Cases] */ // TODO const should be renamed in line with context (isDriveAllCases)
  const isCaseFolder = computed(() => (currentPage.value === NAVIGATION_PAGES.DRIVE_CASES));

  /** Boolean value is true if we open Folder */
  const isDriveFolder = computed(() => (currentPage.value === NAVIGATION_PAGES.DRIVE_FOLDER));

  /** Boolean value should be true if we open Case from Drive My [Drive -> (My) Case] */
  const isCaseView = computed(() => currentPage.value === NAVIGATION_PAGES.CASE_VIEW);

  /** Boolean value should be true if we in Drive Network folder */
  const isNetwork = computed(() => route.meta.isNetwork || false);

  /** Boolean value is true if we open Network Case in Drive Network [Drive -> Network -> Case] */
  const isNetworkCaseView = computed(() => (currentPage.value === NAVIGATION_PAGES.CASE_VIEW && isNetwork.value));

  /** Boolean value is used to hide big round button in Drive (at bottom right corner) */
  const hideAppButton = computed(() => (route.meta.hideAppButton || false) || (driveStore.isPhotoSelector || driveStore.isMixedSelector || driveStore.isCaseSelector));

  /** ??? */
  const isAddMedia = computed(() => (currentPage.value === NAVIGATION_PAGES.DRIVE_PHOTOS));

  /** Constants for double tabs navigation [Drive]<->[Network] */
  const navigationData: INavigation[] = [
    {
      label: isCorporate.value ? 'drive.toggle.corporate' : 'drive.toggle.your_drive',
      routeTo: '/drive',
      activePage: NAVIGATION_PAGES.DRIVE,
    },
    {
      label: 'drive.toggle.network',
      routeTo: '/drive/network',
      activePage: NAVIGATION_PAGES.NETWORK,
    },
  ];

  return {
    currentPage,
    isCorporate,

    navigationData,

    isDrive,
    isCaseFolder,
    isCaseView,

    isDriveFolder,

    isNetwork,
    isNetworkCaseView,

    isAddMedia,

    hideAppButton,
  };
}
